import { useState } from "react";
import { useApi } from "src/api";
import { Button } from "src/elements";
import { downloadFileFromUrl } from "src/utils/downloadFile";

interface Props {
  merchflowId: number;
  storeCode: string;
  storePogId: number;
  isCompact?: boolean;
}

export const StorePogLogsButton = ({ merchflowId, storeCode, storePogId, isCompact }: Props) => {
  const {
    getMerchflowStorePogLogsApi,
    getMerchflowStoreOriginalPsaDownloadUrlApi,
    getMerchflowStoreProductSyncLogDownloadUrlApi,
  } = useApi();

  // Loading with state, because all stores page has many logs buttons, need to show spinner only for the one button.
  const [isLoading, setIsLoading] = useState(false);

  const downloadLogs = async (
    logsType:
      | "pm_data_path"
      | "ff_data_path"
      | "pogger_request_path"
      | "pogger_response_path"
      | "update_request_path"
      | "update_response_path",
  ) => {
    setIsLoading(true);
    const response = await getMerchflowStorePogLogsApi(storePogId);

    if (response && response[logsType]) {
      await downloadFileFromUrl(response[logsType]);
    }
    setIsLoading(false);
  };

  const downloadOriginalPsa = async () => {
    setIsLoading(true);
    const response = await getMerchflowStoreOriginalPsaDownloadUrlApi(merchflowId, storeCode);

    if (response?.url) {
      await downloadFileFromUrl(response.url);
    }
    setIsLoading(false);
  };

  const downloadProductSyncLog = async () => {
    setIsLoading(true);
    const response = await getMerchflowStoreProductSyncLogDownloadUrlApi(merchflowId, storeCode);

    if (response?.url) {
      await downloadFileFromUrl(response.url);
    }
    setIsLoading(false);
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      dropdown={[
        { label: "PM data", onClick: () => downloadLogs("pm_data_path") },
        { label: "FF data", onClick: () => downloadLogs("ff_data_path") },
        { label: "Pogger request", onClick: () => downloadLogs("pogger_request_path") },
        { label: "Pogger response", onClick: () => downloadLogs("pogger_response_path") },
        { label: "Update request", onClick: () => downloadLogs("update_request_path") },
        { label: "Update response", onClick: () => downloadLogs("update_response_path") },
        { label: "Download original PSA", onClick: downloadOriginalPsa },
        { label: "Download PSA product sync report", onClick: downloadProductSyncLog },
      ]}
      isLoading={isLoading}
      iconRight={isCompact ? { name: "arrowDown" } : undefined}
      width={isCompact ? "32px" : undefined}
    >
      {!isCompact ? "Logs" : undefined}
    </Button>
  );
};
